import { useIndexSore } from '@/store/modules/app'
import { storeToRefs } from 'pinia' //引入pinia

export default {
    hasButton: (el, binding) => {
        const menuUrl = window.location.pathname.substring(1, window.location.pathname.length)
        const store = useIndexSore()
        const { subMenuState } = storeToRefs(store)
        if (subMenuState.value) {
            subMenuState.value.forEach(item => {
                if (item.menu_router == menuUrl) {
                    if (item.grand && item.grand.length > 0) {
                        // for (let ele = 0; ele < item.grand.length; ele++) {
                        //   const element = item.grand[ele];
                        //   if(!element.menu_router == binding.value){
                        //     console.log(el,'2222222222222222')
                        //     el.style.display = "none";
                        //   }else {

                        //   }
                        // }
                        if (!item.grand.some(element => element.menu_router == binding.value)) {
                            el.style.display = 'none'
                        } else {
                        }
                    } else {
                        // el.style.display = "none";
                    }
                }
            })
        }
    },
    selectMore: (el, binding) => {}
}
